// Courses API utility functions

import { API_BASE_URL, getAuthHeaders } from './apiConfig';

const COURSES_API = `${API_BASE_URL}/courses`;

// Fetch all courses
export async function fetchCourses() {
  const response = await fetch(COURSES_API, { headers: { ...getAuthHeaders() } });
  return response.json();
}

// Get course by ID
export async function fetchCourse(courseId) {
  const response = await fetch(`${COURSES_API}/${courseId}`, { headers: { ...getAuthHeaders() } });
  return response.json();
}
